import { Stack, Typography, useTheme, LinearProgress } from "@mui/material";

export interface RatingDistributionData {
  rating: number;
  count: number;
  percentage: number;
}

interface RatingDistributionProps {
  data?: RatingDistributionData[];
  totalReviews?: number;
}

const RatingDistribution = ({ data }: RatingDistributionProps) => {
  const theme = useTheme();

  return (
    <Stack spacing={1.2} >
      {data?.map((item) => (
        <Stack
          key={item.rating}
          direction="row"
          alignItems="center"
          spacing={2}
        >
          <Stack direction="row" alignItems="center">
            <Typography
              sx={{
                color: "#212B36",
                fontWeight: "bold",
              }}
            >
              {item?.rating} Star
            </Typography>
          </Stack>

          <Stack sx={{ flex: 1, maxWidth: 260, }}>
            <LinearProgress 
              variant="determinate"
              value={item.percentage}
              sx={{
                height: 4,
                borderRadius: 4,    
                width: "100%",      
                backgroundColor: theme.palette.grey[200],
                "& .MuiLinearProgress-bar": {
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: 4,
                },
              }}
            />
          </Stack>

          <Typography
            sx={{
              fontSize: "14px",
              color: theme.palette.grey[600],
              minWidth: 50,
              textAlign: "right",
            }}
          >
            {item.count.toLocaleString()}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export { RatingDistribution };
